import React, { useContext, useEffect, useState } from 'react';
import LoginContext from '../../context';

export default function NewResultTable({ gameType }) {
  const { token } = useContext(LoginContext);
  const [gameHistory, setGameHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const page = 1;
  const size = 15;

  useEffect(() => {
    const fetchGameHistory = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = `${process.env.REACT_APP_BASE_URL}/api/transactions/my-game-history?game_type=${gameType}&page=${page}&size=${size}`;
        console.log(url);
        const res = await fetch(url, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token?.token}`,
          },
        });
        if (!res.ok) throw new Error('데이터를 불러오지 못했습니다.');
        const data = await res.json();
        console.log('---------------------------------------------------');
        console.log(data);
        setGameHistory(data.results || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    if (token?.token && gameType) fetchGameHistory();
  }, [token, gameType]);

  return (
    <>
      <div className="overflow-x-auto rounded-[20px] lg:rounded-[40px]">
        <table className="font-KoreanTITGD table-auto w-full min-w-[800px]">
          <thead>
            <tr>
              <th className=" border-x border-white/10 h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white px-[15px] py-5 bg-[#1e1f22]">
                게임 이름
              </th>
              <th className=" border-x border-white/10 h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white px-[15px] py-5 bg-[#1e1f22]">
                상세
              </th>
              <th className=" border-x border-white/10 h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white px-[15px] py-5 bg-[#1e1f22]">
                스코어
              </th>
              <th className="border-x border-white/10 h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white px-[15px] py-5 bg-[#1e1f22]">
                결과
              </th>
              <th className="  h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white px-[15px] py-5 bg-[#1e1f22]">
                경기일시
              </th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan={7} className="text-center text-white py-10">
                  불러오는 중...
                </td>
              </tr>
            )}
            {error && (
              <tr>
                <td colSpan={7} className="text-center text-red-500 py-10">
                  {error}
                </td>
              </tr>
            )}
            {!loading && !error && gameHistory.length === 0 && (
              <tr>
                <td colSpan={7} className="text-center text-white py-10">
                  데이터가 없습니다.
                </td>
              </tr>
            )}
            {!loading &&
              !error &&
              gameHistory.map((item, idx) => (
                <tr key={item.provider_id || idx}>
                  <td className="border-x border-white/10 h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white px-[15px] py-5 bg-[#151616]">
                    {item.game_title || '-'}
                  </td>
                  <td className="border-x border-white/10 h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white px-[15px] py-5 bg-[#151616]">
                    {item.description || '-'}
                  </td>
                  <td className="border-x border-white/10 h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] px-[15px] py-5 bg-[#151616]">
                    <span
                      className={`${
                        Number(item.amount) > 1
                          ? 'text-green-500'
                          : Number(item.amount) < 0
                          ? 'text-red-500'
                          : 'text-white'
                      }`}
                    >
                      {item.amount || '-'}
                    </span>
                  </td>
                  <td className="border-x border-white/10 h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white px-[15px] py-5 bg-[#151616]">
                    {item.transaction_type || '-'}
                  </td>
                  <td className="h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white px-[15px] py-5 bg-[#151616]">
                    {item.processed_at || '-'}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
